import { __get } from "noood/net/xhr";
export var SessionManager = {
  // endpoint should be a url that returns
  validate: function validate(_ref) {
    var endpoint = _ref.endpoint,
      callback = _ref.callback;
    //  console.log(`validating @ `, endpoint);
    __get(endpoint, {
      base_url: ""
    }, function (res) {
      var _res$http;
      callback === null || callback === void 0 || callback(((_res$http = res.http) === null || _res$http === void 0 ? void 0 : _res$http.code) === 200);
    });
  }
};